import script from "./VolunteerApplyView.vue?vue&type=script&setup=true&lang=js"
export * from "./VolunteerApplyView.vue?vue&type=script&setup=true&lang=js"

import "./VolunteerApplyView.vue?vue&type=style&index=0&id=c4852d38&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c4852d38"]])

export default __exports__